module.exports = __webpack_public_path__ + "static/siriusxm-f344651724773abab19cbee83c62fde0.png";